import type {ReactElement} from 'react';
import {PhoneInput} from 'react-international-phone';
import 'react-international-phone/style.css';
import './phone-number-input.scss';
import {getPhoneNumberAfterDialCodeSelection} from '@Utils/phone.util';
import type {PhoneInputChangeCallbackMetadata, PhoneNumberInputProps} from './phone-number-input.types';
import {DEFAULT_COUNTRY, PhoneNumberInputSize} from './phone-number-input.types';

export function PhoneNumberInput({phoneNumber, onInputChange, className = '', size = PhoneNumberInputSize.MEDIUM, unstyled = false, ...phoneInputProps}: PhoneNumberInputProps): ReactElement<any> {
  const onChange = (updatedNumber: string, metaData?: PhoneInputChangeCallbackMetadata): void => {
    onInputChange(getPhoneNumberAfterDialCodeSelection(phoneNumber, updatedNumber, metaData?.country.dialCode), metaData);
  };

  const containerClassName = unstyled ? className : `phone-number-input-container ${className} ${size === PhoneNumberInputSize.SMALL ? 'small' : 'medium'}`;

  return (
    <div className={containerClassName}>
      <PhoneInput
        value={phoneNumber}
        onChange={onChange}
        defaultCountry={phoneInputProps.defaultCountry ?? DEFAULT_COUNTRY}
        placeholder="+1 201 555-0123"
        className="phone-number-input"
        {...phoneInputProps}
      />
    </div>
  );
}
